// extracted by mini-css-extract-plugin
module.exports = {"Card":"class-card_Card__2Br_-","CardImage":"class-card_CardImage__2PSfs","CardFooter":"class-card_CardFooter__3OUL7","CardTitle":"class-card_CardTitle__sbWuX"};